import { isPlainObject, isString, isArray } from '@/utils/is'
import { convertBeijingTime2WarehouseTime } from '@/utils/date'

const dateFormat = 'YYYY-MM-DD HH:mm'
const dateTimeRE = /^\d{4}([-:])(\d{2})\1(\d{2})(\s+(\d{2}:){2}(\d{2}))?$/

/**
 * 同一格式化请求参数中的momentjs时间对象
 * @param data
 * @returns
 */
export function formatDataDate(
  data: Recordable,
  transformRequestTimeExcludeKeys: string[],
  trimExcludeKeys: string[],
) {
  if (!isPlainObject(data) && !isArray(data)) {
    return
  }

  Object.keys(data).forEach((key) => {
    if (transformRequestTimeExcludeKeys.includes(key)) {
      return
    }

    const value = data[key]
    if (value && value._isAMomentObject) {
      data[key] = value.format(dateFormat)
    }

    if (isString(value)) {
      if (!trimExcludeKeys.includes(key)) {
        data[key] = value.trim()
      }
      if (dateTimeRE.test(value)) {
        data[key] = convertBeijingTime2WarehouseTime(value, true)
      }
      if (data[key] === '') {
        data[key] = undefined
      }
    } else if (isPlainObject(value) || Array.isArray(value)) {
      formatDataDate(value, transformRequestTimeExcludeKeys, trimExcludeKeys)
    }
  })
}

/**
 * 将接口返回数据的时间全部转换为仓库时间
 * @param data
 */
export function transformResponseTime(data: any, replaceStr = '--', excludeKeys: string[] = []) {
  if (data === null || typeof data !== 'object') {
    return
  }

  Object.keys(data).forEach((key) => {
    const value = data[key]
    if (isString(value)) {
      if (
        value === '0000-00-00 00:00:00' ||
        value === '1000-01-01 00:00:00' ||
        value === '1900-01-01 00:00:00' ||
        value === '1900-01-01'
      ) {
        data[key] = replaceStr
        return
      }
      if (excludeKeys.includes(key)) {
        return
      }
      if (dateTimeRE.test(value)) {
        data[key] = convertBeijingTime2WarehouseTime(value)
      }
    } else if (Array.isArray(value) || isPlainObject(value)) {
      transformResponseTime(value, replaceStr, excludeKeys)
    }
  })
}

/**
 * 添加时间戳
 * @param appendAtURL
 * @returns
 */
export function joinTimeStamp(appendAtURL = false) {
  const time = Date.now()

  if (appendAtURL) {
    return `?_t=${time}`
  }

  return { _t: time }
}
